import type { FaireProductEntity } from "../../entity_types/product";

export const p_sx6zye8wdd: FaireProductEntity = {
  token: "p_sx6zye8wdd",
  type: "product",
  name: "18k GF Marine Link Mixed Blue Eye Bracelet And Neck",
  brandToken: "b_9zxdpx73wa",
  brandName: "Milie",
  imageUrl:
    "https://cdn.faire.com/fastly/b4f04ce2020e561af25132e66292c652d8e7cb12aed2bb89bd33f265bce69ac0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abaa3e5e342bfc8f4884609bbab725e0ed5cb017234abf9615aac8e1329579d9.jpeg",
    "https://cdn.faire.com/fastly/a8d62519b3c910272866552dc44be786e04099cac0ae4d0493e7140b06b33a29.jpeg",
    "https://cdn.faire.com/fastly/2ea2d71a1ba3fc14c242dd91ced04f72d38684ece66627a7af6dd04c1f025fc5.jpeg",
    "https://cdn.faire.com/fastly/bb0cf411f086ccea5741b0afbc792dc89504e063995e6ecce041f9d753131287.jpeg",
    "https://cdn.faire.com/fastly/d1c31a03757ea4b685c8ec101b1ef47a77b35f77c409e58bd86142205045285d.jpeg",
  ],
  priceDollars: 14.8,
  description:
    "18k GF marine link mixed with blue evil eye bracelet and necklace \n\nNote: Sold separately or as a set! \n\n * Nickel Free \n * Hypoallergenic \n * Water friendly \n * Made in Brazil \nOur online store was developed to help you find the most unique styles of modern designs, always looking for elegance and market trends. Here you will find ways to better make your jewelry through quality, seeking harmony, exclusivity and impeccable finish.",
  tags: [],
  msrpDollars: 29.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:09.367Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
